import React, { Component } from 'react';
import * as TenantUsersAction from './actions';
import { toast } from 'react-toastify';
import service from '../services/graphQlServices';
import _ from 'lodash';

class TenantUsersController extends Component {
	checkUserLoggedIn = () => {
		if (!localStorage.getItem('usertoken')) {
			window.open('https://vendors.huemn.com', '_self');
		}
	};

	getUserDetails = async () => {
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');

		let response = await TenantUsersAction.userDetails(usertoken);

		if (response[0] === true) {
			this.setState({
				userDetails: response[1],
			});
		}
	};
	addTenantMember = async (mutation, variables, add = null, successMessage = null) => {
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(
					mutation,
					variables,
					vendorID,
					usertoken,
					'vendors',
				);
				if (response[0] == true) {
					resolve(true);
					if (this.props.userModalType === 'add') this.props.close();
					else {
						const userData =
							response[1].data.updateTenantUser ||
							response[1].data.updateTenantUserSuspension;
						let accessibleWorkspaces = [];
						_.map(
							userData.accessibleTenants,
							(tenant, key) => {
								accessibleWorkspaces.push(tenant['workspaceId']);
							},
						);

						this.setState({
							firstName: userData.firstName,
							lastName: userData.lastName,
							email: userData.email,
							phoneNumber: userData.phoneNumber,
							displayName: userData.displayName,
							isShooter: userData.isShooter,
							accessibleTenants: userData.accessibleTenants,
							accessibleWorkspaces,
							isFreelancer: userData.isFreelancer,
							isSuspended: userData.isSuspended,
						});
					}
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: successMessage
					? successMessage
					: add === true
						? 'Member added successfully!'
						: 'Member edited successfully!',
				error: {
					render({ data }) {
						return `${data}`;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 700,
			},
		);
	};

	updateMemberWorkspaceAccess = async (mutation, variables, type) => {
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(
					mutation,
					variables,
					vendorID,
					usertoken,
					'vendors',
				);
				if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
					let workspace;
					let accessibleWorkspaces;
					workspace = variables.accessInput[`${type}WorkspaceAccess`];
					accessibleWorkspaces = this.state.accessibleWorkspaces;
					const index = accessibleWorkspaces.indexOf(workspace);
					if (index > -1) {
						accessibleWorkspaces.splice(index, 1);
					}
					this.setState({
						accessibleWorkspaces,
					});
				}
			}),
			{
				pending: 'Loading',
				success: 'Workspace Access updated successfully!',
				error: {
					render({ data }) {
						return `${data}`;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 700,
			},
		);

		if (response[0] == true) {
		} else {
		}
	};

	getBranchList = async (query) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, {}, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let branchesList = response[1].data.branchesList;
			let branchesListOption = _.map(branchesList, (branch, key) => {
				return {
					label: branch.branchId,
					value: branch.branchId,
					key: branch.branchId,
					name: branch.branchId,
				};
			});

			this.setState({
				branchesList,
				branchesListOption,
				isBranchesListLoading: false,
				isLoading: false,
			});
		}
	};
}

export default TenantUsersController;
